module.exports = __webpack_public_path__ + "assets/img/zh-Hant-a80759fa.png";